import { ReactNode } from "react";
import { ArtAppLoader } from "@art/shared-ui";
import AccessDenied from "../../components/access-denied";
import { usePermissionsContext } from "./permissions-provider";
import { useAttributePermission } from "./usePermission";

interface RequireAttributePermissionProps {
  application: string;
  feature: string;
  attribute: string;
  children: ReactNode;
}

export function RequireAttributePermission({
  application,
  feature,
  attribute,
  children,
}: RequireAttributePermissionProps) {
  const { loading } = usePermissionsContext();
  const allowed = useAttributePermission(application, feature, attribute);

  if (loading) return <ArtAppLoader />;
  return allowed ? <>{children}</> : <AccessDenied />;
}
